<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"/>
    </div>
    <b-card :header="cardTitle" v-if="sorteio" class="card-edicao">
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Titulo" class="mt-3">
            <b-form-input v-model="sorteio.titulo"/>
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Descrição" class="mt-3">
            <b-form-input v-model="sorteio.descricao"/>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Inicial" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="sorteio.datainicial"
              :language="ptBR"
              :format="customFormatter"
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Final" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="sorteio.datafinal"
              :language="ptBR"
              :format="customFormatter"
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="danger" class="mt-3 botao" @click="goBack()">Cancelar</b-button>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="success" class="mt-3 botao" @click="save()">Salvar</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style>
.card-edicao > .card-body {
  padding-top: 0.25rem !important;
}
.date-input > .form-control > div > input {
  width: 100%;
  height: 100%;
  border: none;
  color: #5c6873;
}
.botao {
  width: 100% !important;
}
.input-group-text {
  width: 100px !important;
}
.form-control > input {
  width: calc(100% - 20px) !important;
  height: 100% !important;
  border: none !important;
  padding: 0 !important;
  color: #5c6873;
}
</style>


<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vuejs-timepicker";
import moment from "moment";

export default {
  name: "editar-sorteio",
  components: { Loading, Datepicker, moment, VueTimepicker },
  data: function() {
    return {
      isLoading: false,
      id: null,
      sorteio: null,
      cardTitle: "",
      ptBR: ptBR
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    save() {
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.isLoading = true;
      const options = { title: "Aviso", size: "sm" };
      if (moment(this.sorteio.datainicial).isAfter(this.sorteio.datafinal)) {
        this.isLoading = false;
        this.$dialogs.alert("Datas inválidas.", options).then(res => {});
      } else if (moment(this.sorteio.datainicial).isAfter(tomorrow)) {
        this.isLoading = false;
        this.$dialogs.alert("Datas inválidas.", options).then(res => {});
      } else if (moment(Date.now()).isAfter(this.sorteio.datafinal)) {
        this.isLoading = false;
        this.$dialogs.alert("Datas inválidas.", options).then(res => {});
      } else {
        this.sorteio.datainicial = moment(this.sorteio.datainicial).format();
        this.sorteio.datafinal = moment(this.sorteio.datafinal).format();
        axios
          .post(
            `${config.default.servidor}/gerencial/sorteio`,
            {
              id: this.sorteio.id,
              titulo: this.sorteio.titulo,
              descricao: this.sorteio.descricao,
              datainicial: moment(this.sorteio.datainicial).set({hour:0,minute:0,second:0,millisecond:0}),
              datafinal: moment(this.sorteio.datafinal).set({hour:23,minute:59,second:59,millisecond:0})
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(response => {
            this.isLoading = false;
            if (response.status == 200) {
              const options = { title: "Aviso", size: "sm" };
              this.$dialogs
                .alert("Alterado com sucesso.", options)
                .then(res => {
                  this.$router.go(-1);
                });
            }
          })
          .catch(error => {
            const options = { title: "Aviso", size: "sm" };
            this.$dialogs.alert(`Erro: ${error}`, options).then(res => {
              console.log(res);
            });
            this.$router.go(-1);
          });
      }
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },
  beforeMount() {
    this.isLoading = true;
    this.id = this.$route.params.id;
    this.cardTitle = `Sorteio`;
    if (this.id == null) {
      const options = { title: "Aviso", size: "sm" };
      this.$dialogs
        .alert("Não encontramos o sorteio indicado.", options)
        .then(res => {
          console.log(res);
        });
      this.$router.go(-1);
    } else {
      axios
        .get(
          `${config.default.servidor}/gerencial/sorteio/dados/${this.id}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          this.sorteio = response.data.data;
          this.isLoading = false;
        })
        .catch(error => {
          const options = { title: "Aviso", size: "sm" };
          this.$dialogs.alert(`Erro: ${error}`, options).then(res => {
            console.log(res);
          });
          this.$router.go(-1);
        });
    }
  }
};
</script>

